import React, { Fragment, useEffect, useState, useCallback } from 'react'
import Button from '@mui/material/Button'
import ResponsiveDataGrid from '../../themes/components/ResponsiveDataGrid';
import PageShell from '../../themes/components/PageShell';
import PageHeader from '../../themes/components/PageHeader';
import PageContent from '../../themes/components/PageContent';
import Action from '../../themes/components/Action';
import ResponsiveDialog from '../../themes/components/ResponsiveDialog';
import LocalSubnav from '../../themes/components/LocalSubnav';
import ToolDialogShell from '../../themes/components/ToolDialogShell';
import WorkflowDialogShell from '../../themes/components/WorkflowDialogShell';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import { Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom'
import { GetInvoices, GetInvoiceById, UpdateLineItem, RemoveLineItem, PayLineItem, AddRemark, CancelInvoice } from '../../REST/invoices';
import { GetList } from '../../REST/crud';
import { GetCompanies, GetCompanyById, GetActiveCompanies } from '../../REST/company'
import AuthProvider from '../Authentication/authProvider';
import { Box, Alert, Checkbox, Chip, IconButton, Paper, Stack, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MenuIcon from '@mui/icons-material/Menu';
import moment from 'moment';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { PayCard, PayCardStripe, PayAchStripe } from '../WaitList/stripePayment';
import RemarksView from '../Utilities/remarks';
import InvoiceCopyDialog from './InvoiceCopyDialog';
import EmailIcon from '@mui/icons-material/Email';
import SendTemplateDialog from '../../themes/components/SendTemplateDialog';
import AddIcon from '@mui/icons-material/Add'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import NativeSelect from '@mui/material/NativeSelect';
import DatePicker from '@mui/lab/DatePicker';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { AddInvoice, AddLineItem, UpdateComments, UpdateInvoiceLateFee } from '../../REST/invoices';
import Access from '../../Utils/authorize';
import { getAmount } from '../../helpers/amount';
import { getOptions } from '../../helpers';

function Invoices() {

    const navigate = useNavigate()
    const [open, setOpen] = useState(false)

    const amountParser = (params) => getAmount(params.value)

    // minVisible controls which breakpoint a column first appears at.
    // xs = always visible, sm = tablet+, md = desktop+, etc.
    const columns = [
       // { field: 'tenantId',     headerName: 'Company Name',   flex: 0.5, minVisible: 'lg' },
        { field: 'name',         headerName: 'Invoice Name',   flex: 0.6, minVisible: 'lg' },
        { field: 'invoiceNumber',headerName: 'Invoice #',      flex: 0.5, minVisible: 'xs' },
        { field: 'invoiceDate',  headerName: 'Invoice Date',   flex: 0.5, minVisible: 'lg', filterable: false },
        { field: 'duesDate',     headerName: 'Due Date',       flex: 0.5, minVisible: 'xs', filterable: false },
        { field: 'status',       headerName: 'Status',         flex: 0.5, minVisible: 'lg', type: 'singleSelect', valueOptions: ['Created', 'Unpaid', 'Partially Paid', 'Paid', 'Overdue', 'Payment Reversed', 'Cancelled'] },
        { field: 'amountTotal',  headerName: 'Amount Total',   flex: 0.5, minVisible: 'lg', renderCell: amountParser, type: 'number', filterable: false },
    ];

    const fetchInvoices = useCallback(async (page, limit, filters, sort) => {
        const params = { page, limit }

        if (Object.keys(filters).length > 0) {
            params.filters = JSON.stringify(filters)
        }

        if (sort) {
            params.sort = JSON.stringify(sort)
        }

        const result = await GetInvoices(params);

        if (result.data?.data) {
            const transformed = result.data.data.map(e => {
                const { lineItems, paymentDate, dueDate, invoiceDate } = e
                let amountDue = 0.0
                let amountPaid = 0.0
                let amountTotal = 0.0
                lineItems.forEach(each => {
                    const { charges } = each
                    if (each.receiptId) amountPaid = amountPaid + each.charges * each.amount
                    amountTotal = amountTotal + charges * each.amount
                })
                amountDue = amountTotal - amountPaid
                return {
                    ...e,
                    id: e._id, amountDue, amountPaid, amountTotal,
                    invoiceDate: invoiceDate === 'NA' ? 'NA' : moment(invoiceDate).format('MM/DD/YYYY hh:mm A'),
                    paymntDate: paymentDate === 'NA' ? 'NA' : moment(paymentDate).format('MM/DD/YYYY'),
                    duesDate: dueDate === 'NA' ? 'NA' : moment(dueDate).format('MM/DD/YYYY')
                }
            });
            return { data: transformed, pagination: result.data.pagination };
        }

        return { data: [], pagination: { total: 0 } };
    }, []);

    const handleRowClick = (row) => {
        navigate('/invoices/' + row.id);
    };

    return (
        <PageShell>
            <PageHeader
                title="Invoices"
                back
                onBack={() => navigate(-1)}
                actions={
                    <>
                        {Access.isInternal() && (
                            <Action
                                primary
                                icon={<AddIcon />}
                                label="Add Invoice"
                                onClick={() => setOpen(true)}
                            />
                        )}
                    </>
                }
            />

            <PageContent fill>
                <ResponsiveDataGrid
                    columns={columns}
                    fetchData={fetchInvoices}
                    initialPageSize={10}
                    pageSizeOptions={[10, 25, 50, 100]}
                    onRowClick={handleRowClick}
                    enableExport={true}
                    initialSortModel={[{ field: 'invoiceDate', sort: 'desc' }]}
                    sortingOrder={['desc', 'asc']}
                />
            </PageContent>

            <CreateInvoice open={open} handleClose={() => setOpen(false)} />
        </PageShell>
    );
}

export default function InvoiceView() {
    const location = useLocation()

    return <Fragment>
        {location.pathname === '/invoices' && <Invoices />}
        <Routes>
            {/* <Route path='add' element={<AuthProvider><AddAgreementView /></AuthProvider>} /> */}
            <Route path='/:id' element={<AuthProvider><InvoiceDetail /></AuthProvider>} />
        </Routes>
    </Fragment>
}



function CreateInvoice({ open = false, handleClose }) {

    const [options, setOptions] = useState([])
    const [lateFeeType, setLateFeeType] = useState('')
    const [lateFeeValue, setLateFeeValue] = useState('')
    const navigate = useNavigate()

    const handleLateFeeTypeChange = (e) => {
        setLateFeeType(e.target.value)
        setLateFeeValue('')
    }

    const schema = yup.object({
        name: yup.string().trim().required(),
        description: yup.string().trim().required(),
        dueDate: yup.date().required(),
        tenantId: yup.string().trim().required()
    }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: { name: '', description: '', dueDate: '', tenantId: '' },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        (async () => {
            const resp = await GetActiveCompanies()
            if (Array.isArray(resp.data)) {
                setOptions(resp.data.map(x => ({ label: x.name, value: x._id })))
            }
        })()
    }, [])

    useEffect(() => {
        clearErrors()
        reset()
        setLateFeeType('')
        setLateFeeValue('')
    }, [open, clearErrors, reset])

    const onSubmit = async (data) => {
        const payload = { ...data, isAdhoc: true, generationType: 'Manual' }
        if (lateFeeType) {
            payload.lateFeeType = lateFeeType
            payload.lateFeeValue = lateFeeValue !== '' ? Number(lateFeeValue) : null
        }
        const result = await AddInvoice(payload)
        navigate(result.data._id)
    }

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

    return <WorkflowDialogShell
        open={open}
        onClose={handleClose}
        onSave={handleSubmit(onSubmit)}
        title="Create Invoice"
    >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Controller name="name" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.name)} required helperText={errors.name && errors.name.message} fullWidth label='Name' {...field} />} />
            <Controller name="description" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.description)} required helperText={errors.description && errors.description.message} fullWidth label='Description' {...field} />} />
            <Controller name="dueDate" control={control} render={({ field }) => <DatePicker variant='standard' margin='dense' label='Due Date' renderInput={(params) => <TextField helperText={errors.dueDate && errors.dueDate.message} fullWidth variant='standard' {...params} required error={isError(errors.dueDate)} onChange={field.onChange} />} {...field} />} />
            <Controller name="tenantId" control={control} render={({ field }) =>
                <FormControl error={isError(errors.tenantId)} variant='standard' margin='dense' fullWidth required>
                    <InputLabel shrink>{'Company'}</InputLabel>
                    <NativeSelect {...field} >{getOptions(options, 'value', 'label')}</NativeSelect>
                    {errors.tenantId && <FormHelperText>{errors.tenantId.message}</FormHelperText>}
                </FormControl>} />
            <FormControl variant='standard' margin='dense' fullWidth>
                <InputLabel shrink>Late Fee Type (optional)</InputLabel>
                <NativeSelect value={lateFeeType} onChange={handleLateFeeTypeChange} sx={{ mt: 2 }}>
                    <option value=''>None</option>
                    <option value='Percent'>Percentage Based</option>
                    <option value='Flat'>Flat Amount</option>
                </NativeSelect>
            </FormControl>
            {lateFeeType && (
                <TextField margin='dense' type='number' fullWidth
                    label={lateFeeType === 'Flat' ? 'Late Fee ($ flat amount)' : 'Late Fee (%)'}
                    value={lateFeeValue} onChange={e => setLateFeeValue(e.target.value)} />
            )}
        </LocalizationProvider>
    </WorkflowDialogShell>
}

export function InvoiceDetail({ editor = true }) {
    const navigate = useNavigate()
    const { id } = useParams()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const [data, setData] = useState({ lineItems: [] })
    const [select, setSelect] = useState([])
    const [edit, setEdit] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [pay, setPay] = useState(false)
    const [open, setOpen] = useState(false)
    const [openCmts, setOpenCmts] = useState(false)
    const [remarksOpen, setRemarksOpen] = useState(false)
    const [toolsOpen, setToolsOpen] = useState(false)
    const [sendEmailOpen, setSendEmailOpen] = useState(false)
    const [tenant, setTenant] = useState('')
    const [lateFeeEditOpen, setLateFeeEditOpen] = useState(false)
    const [sysLateFeeType, setSysLateFeeType] = useState(null)
    const [sysLateFeeValue, setSysLateFeeValue] = useState(null)

    useEffect(() => {
        GetList('SystemSetting').then(resp => {
            const settings = Array.isArray(resp.data) ? resp.data : (resp.data?.data || [])
            const t = settings.find(s => s.name === 'LATE_FEE_TYPE')?.value || null
            const v = settings.find(s => s.name === 'LATE_FEE_VALUE')?.value || null
            setSysLateFeeType(t)
            setSysLateFeeValue(v)
        }).catch(() => {})
    }, [])

    const [notFound, setNotFound] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                const resp = await GetInvoiceById(id)
                if (!resp.data || !resp.data.lineItems) {
                    setNotFound(true)
                    return
                }
                setData(resp.data)
                if (editor) {
                    const tenant = await GetCompanyById(resp.data.tenantId)
                    setTenant(tenant.data ? tenant.data.name : ' ')
                }
            } catch (ex) {
                setNotFound(true)
            }
        })()
    }, [id, refresh, editor])

    if (notFound)
        return (
            <PageShell>
                <PageHeader title="Invoice Not Found" back onBack={() => navigate(-1)} />
                <PageContent>
                    <Alert severity="error">This invoice could not be found. It may have been removed or the link is invalid.</Alert>
                </PageContent>
            </PageShell>
        )

    const toggleRefresh = () => {
        setRefresh(e => !e)
        setEdit(null)
        setPay(false)
        setSelect([])
    }

    const refreshData = () => {
        setRefresh(e => !e)
        setSelect([])
    }

    const handleSelected = (checked, id) => {
        if (!checked || select.includes(id))
            setSelect(x => x.filter(e => e !== id))
        else
            setSelect(x => x.concat([id]))
    }

    const getDate = (date) => {
        const result = moment(date)
        if (result.isValid())
            return result.format('MM/DD/YYYY')
        return 'NA'
    }

    const amountDue = (items = []) => items.filter(e => !e.receiptId).reduce((acc, val) => acc + val.charges * val.amount, 0)
    const amountPaid = (items = []) => items.filter(e => e.receiptId).reduce((acc, val) => acc + val.charges * val.amount, 0)
    const totalAmount = (items = []) => items.reduce((acc, val) => acc + val.charges * val.amount, 0)
    const selectedTotal = () => data.lineItems.filter(e => select.includes(e._id)).reduce((acc, val) => acc + val.amount * val.charges, 0)

    const updateLine = (entity) => UpdateLineItem(id, entity).then(toggleRefresh)
    const removeLine = (uid) => {
        RemoveLineItem(id, uid).then((rslt) => {
            if (rslt.data.lineItems.length == 0)
                cancelInvoice()
            else
                toggleRefresh()
        })
    }
    const addRemark = (doc) => AddRemark(id, doc).then(toggleRefresh)
    const cancelInvoice = () => CancelInvoice(id).then(toggleRefresh)

    const handleCmts = (data) => {
        (async () => {
            await UpdateComments(id, data)
            setOpenCmts(false)
            toggleRefresh()
        })()
    }

    const summaryItems = [
        { label: 'Tenant', value: tenant || ' ' },
        { label: 'Invoice Number', value: data.invoiceNumber || 'NA' },
        { label: 'Invoice Date', value: getDate(data.invoiceDate) },
        { label: 'Payment Date', value: getDate(data.paymentDate) },
        { label: 'Due Date', value: getDate(data.dueDate) },
        { label: 'Amount Paid', value: getAmount(amountPaid(data.lineItems)) },
        { label: 'Amount Due', value: getAmount(amountDue(data.lineItems)) },
        { label: 'Total Amount', value: getAmount(totalAmount(data.lineItems)) },
    ]

    if (data)
        return (
            <PageShell>
                {edit && <LineItemView data={edit} handleClose={() => setEdit(null)} open={!!edit} handleSave={updateLine} />}
                {pay && <PayItems open={pay} handleSave={refreshData} id={id} items={data.lineItems} select={select} handleClose={() => setPay(false)} />}
                {openCmts && <AddComments handleClose={() => setOpenCmts(false)} open={openCmts} cmts={data.comments} handleCmts={handleCmts} />}
                {open && <NewLineItemView handleClose={() => setOpen(false)} open={open} toggleRefresh={toggleRefresh} />}
                {lateFeeEditOpen && (
                    <EditLateFeeDialog
                        open={lateFeeEditOpen}
                        invoiceId={id}
                        currentLateFeeType={data.lateFeeType}
                        currentLateFeeValue={data.lateFeeValue}
                        handleClose={() => setLateFeeEditOpen(false)}
                        handleSave={() => { setLateFeeEditOpen(false); toggleRefresh() }}
                    />
                )}
                {editor && (
                    <RemarksView
                        module={'Invoices'}
                        fullWidth
                        docIds={data.remarks}
                        onUpload={e => addRemark(e._id)}
                        open={remarksOpen}
                        onClose={() => setRemarksOpen(false)}
                        showTrigger={false}
                    />
                )}
                <SendTemplateDialog
                    open={sendEmailOpen}
                    onClose={() => setSendEmailOpen(false)}
                    module="Invoices"
                    entityId={id}
                    defaultEmail={data.recipientemail || ''}
                />

                <PageHeader
                    title={`Invoice #${data.invoiceNumber || id}`}
                    back
                    onBack={() => navigate(-1)}
                    actions={
                        isMobile ? (
                            <Action
                                primary
                                icon={<MenuIcon />}
                                label="Invoice Tools"
                                onClick={() => setToolsOpen(true)}
                            />
                        ) : null
                    }
                />

                <PageContent>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row-reverse' },
                            gap: 2,
                            alignItems: 'flex-start',
                        }}
                    >
                        {editor && (
                            <LocalSubnav
                                title="Invoice Tools"
                                mobileLabel="Invoice Tools"
                                open={toolsOpen}
                                onOpen={() => setToolsOpen(true)}
                                onClose={() => setToolsOpen(false)}
                                showMobileTrigger={false}
                                items={[
                                    {
                                        key: 'remarks',
                                        label: 'Remarks',
                                        icon: <EditIcon />,
                                        onClick: () => setRemarksOpen(true),
                                    },
                                    {
                                        key: 'line-items',
                                        label: 'Add Line Item',
                                        icon: <AddIcon />,
                                        onClick: () => setOpen(true),
                                        disabled: !Access.isAdmin('Invoices'),
                                    },
                                    {
                                        key: 'pay',
                                        label: 'Pay Selected',
                                        icon: <AddIcon />,
                                        onClick: () => setPay(true),
                                        disabled: select.length < 1 || data.status === 'Paid',
                                        dividerBefore: true,
                                    },
                                    {
                                        key: 'cancel',
                                        label: 'Cancel Invoice',
                                        icon: <CloseIcon />,
                                        onClick: () => cancelInvoice(),
                                        disabled: !Access.isAdmin('Invoices') || data.status === 'Cancelled',
                                    },
                                    {
                                        key: 'send-email',
                                        label: 'Send Email',
                                        icon: <EmailIcon />,
                                        onClick: () => setSendEmailOpen(true),
                                        dividerBefore: true,
                                    },
                                ]}
                            />
                        )}

                        <Box sx={{ flex: '1 1 auto', minWidth: 0, width: '100%' }}>
                            <Stack spacing={2}>
                                <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
                                    <Stack spacing={2}>
                                        <Stack
                                            direction={{ xs: 'column', sm: 'row' }}
                                            justifyContent="space-between"
                                            spacing={2}
                                            alignItems={{ xs: 'flex-start', sm: 'center' }}
                                        >
                                            <Box>
                                                <Typography variant="body2" color="text.secondary">
                                                    Invoice Id: {id}
                                                </Typography>
                                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                    {tenant}
                                                </Typography>
                                            </Box>
                                            <Chip label={data.status || 'Unknown'} color={data.status === 'Paid' ? 'success' : data.status === 'Cancelled' ? 'default' : 'primary'} />
                                        {data.isAdhoc && <Chip label="Adhoc" color="warning" size="small" />}
                                        </Stack>

                                        <Box
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                                gap: 2,
                                            }}
                                        >
                                            {summaryItems.map((item) => (
                                                <Box key={item.label}>
                                                    <Typography variant="body2" color="text.secondary">
                                                        {item.label}
                                                    </Typography>
                                                    <Typography
                                                        variant="subtitle1"
                                                        sx={{
                                                            fontWeight: item.label.includes('Amount') ? 700 : 600,
                                                            lineHeight: 1.3,
                                                        }}
                                                    >
                                                        {item.value}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Stack>
                                </Paper>

                                <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
                                    <Stack spacing={2}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }}>
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: 600 }}>Late Fee Configuration</Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Applied automatically when this invoice becomes overdue.
                                                </Typography>
                                            </Box>
                                            {editor && (
                                                <Button variant="contained" onClick={() => setLateFeeEditOpen(true)}>Edit</Button>
                                            )}
                                        </Stack>
                                        <Box>
                                            <Typography variant="body2" color="text.secondary">Late Fee Type</Typography>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                {data.lateFeeType === 'Percent' ? 'Percentage Based'
                                                    : data.lateFeeType === 'Flat' ? 'Flat Amount'
                                                    : sysLateFeeType
                                                        ? `${sysLateFeeType === 'Percent' ? 'Percentage Based' : 'Flat Amount'} (system default)`
                                                        : 'Not configured'}
                                            </Typography>
                                        </Box>
                                        {(data.lateFeeType || sysLateFeeType) && (
                                            <Box>
                                                <Typography variant="body2" color="text.secondary">Late Fee Value</Typography>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                    {(() => {
                                                        const type = data.lateFeeType || sysLateFeeType
                                                        const val = data.lateFeeValue != null ? data.lateFeeValue : sysLateFeeValue
                                                        return type === 'Flat' ? `$${val ?? 0}` : `${val ?? 0}%`
                                                    })()}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Stack>
                                </Paper>

                                <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
                                    <Stack spacing={2}>
                                        <Stack
                                            direction={{ xs: 'column', sm: 'row' }}
                                            justifyContent="space-between"
                                            spacing={2}
                                            alignItems={{ xs: 'flex-start', sm: 'center' }}
                                        >
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                    Notes & Notices
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Comments, notices, and supporting communication for this invoice.
                                                </Typography>
                                            </Box>
                                            {editor && (
                                                <Button variant="contained" onClick={() => setOpenCmts(true)}>
                                                    Add Comment
                                                </Button>
                                            )}
                                        </Stack>

                                        <Box>
                                            <Typography variant="body2" color="text.secondary">
                                                Comments
                                            </Typography>
                                            <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                                                {data.comments || 'No comments added yet.'}
                                            </Typography>
                                        </Box>

                                        {editor && (
                                            <InvoiceCopyDialog invoiceData={data} tenant={tenant} />
                                        )}
                                    </Stack>
                                </Paper>

                                {Array.isArray(data.lineItems) && (
                                    <InvoiceLineItemsSection
                                        lineItems={data.lineItems}
                                        select={select}
                                        editor={editor}
                                        status={data.status}
                                        isMobile={isMobile}
                                        onSelect={handleSelected}
                                        onEdit={setEdit}
                                        onRemove={removeLine}
                                        onAdd={() => setOpen(true)}
                                        onPay={() => setPay(true)}
                                        totalAmount={totalAmount}
                                        selectedTotal={selectedTotal}
                                    />
                                )}
                            </Stack>
                        </Box>
                    </Box>
                </PageContent>

                {isMobile && data.status !== 'Paid' && select.length > 0 && (
                    <Box
                        sx={{
                            position: 'sticky',
                            bottom: 0,
                            zIndex: 2,
                            bgcolor: 'background.paper',
                            borderTop: `1px solid ${theme.palette.divider}`,
                            p: 2,
                            pb: `calc(${theme.spacing(2)} + env(safe-area-inset-bottom, 0px))`,
                        }}
                    >
                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    {select.length} selected
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {getAmount(selectedTotal())}
                                </Typography>
                            </Box>
                            <Button variant="contained" onClick={() => setPay(true)}>
                                Pay Selected
                            </Button>
                        </Stack>
                    </Box>
                )}
            </PageShell>
        )

    return <p> No Invoice Found.</p>
}

function InvoiceLineItemsSection({
    lineItems = [],
    select = [],
    editor,
    status,
    isMobile,
    onSelect,
    onEdit,
    onRemove,
    onAdd,
    onPay,
    totalAmount,
    selectedTotal,
}) {
    const canManage = Access.isAdmin('Invoices') && editor

    return (
        <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
            <Stack spacing={2}>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    spacing={2}
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                >
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Line Items
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {lineItems.length} item{lineItems.length === 1 ? '' : 's'} • Total {getAmount(totalAmount(lineItems))}
                            {select.length > 0 ? <> • {select.length} selected ({getAmount(selectedTotal())})</> : ''}
                        </Typography>
                    </Box>

                    {canManage && !isMobile && (
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" startIcon={<AddIcon />} onClick={onAdd}>
                                Add Line Item
                            </Button>
                            {status !== 'Paid' && (
                                <Button variant="outlined" onClick={onPay} disabled={select.length < 1}>
                                    Pay Selected
                                </Button>
                            )}
                        </Stack>
                    )}
                </Stack>

                {isMobile ? (
                    <Stack spacing={2}>
                        {lineItems.map((item) => (
                            <Paper key={item._id} variant="outlined" sx={{ p: 2 }}>
                                <Stack spacing={1.5}>
                                    <Stack direction="row" spacing={1} alignItems="flex-start" justifyContent="space-between">
                                        <Stack direction="row" spacing={1} alignItems="flex-start">
                                            <Checkbox
                                                disabled={!!item.receiptId || item.isPending}
                                                checked={select.includes(item._id)}
                                                onChange={(evt) => onSelect(evt.target.checked, item._id)}
                                                sx={{ p: 0.5 }}
                                            />
                                            <Box>
                                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                                    {item.name}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {item.description}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                        <Chip
                                            size="small"
                                            label={item.receiptId ? 'Paid' : (item.isPending ? 'Pending Clear' : 'Open')}
                                            color={item.receiptId ? 'success' : (item.isPending ? 'warning' : 'default')}
                                        />
                                    </Stack>

                                    <Box
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: 1.5,
                                        }}
                                    >
                                        <InvoiceValue label="Amount" value={getAmount(item.charges)} />
                                        <InvoiceValue label="Quantity" value={item.amount} />
                                        <InvoiceValue label="Line Total" value={getAmount(item.charges * item.amount)} />
                                    </Box>

                                    {canManage && (
                                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                                            <Tooltip title="Edit line item">
                                                <IconButton color="primary" onClick={() => onEdit(item)}>
                                                    <EditIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Remove line item">
                                                <IconButton color="error" onClick={() => onRemove(item.uid)}>
                                                    <DeleteOutlineIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Stack>
                                    )}
                                </Stack>
                            </Paper>
                        ))}
                    </Stack>
                ) : (
                    <Box sx={{ overflowX: 'auto' }}>
                        <table className='table table-condensed table-small' style={{ marginBottom: 0 }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Charge Name</th>
                                    <th>Charge Desc.</th>
                                    <th className='text-right'>Charge Amount</th>
                                    <th className='text-right'>Charge Quantity</th>
                                    <th className='text-right'>Charge Total</th>
                                    <th className='text-right'>Status</th>
                                    {canManage && <th></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {lineItems.map((item) => (
                                    <tr key={item._id}>
                                        <td>
                                            <Checkbox
                                                disabled={!!item.receiptId || item.isPending}
                                                checked={select.includes(item._id)}
                                                onChange={(evt) => onSelect(evt.target.checked, item._id)}
                                            />
                                        </td>
                                        <td>{item.name}</td>
                                        <td>{item.description}</td>
                                        <td className='text-right'>{getAmount(item.charges)}</td>
                                        <td className='text-right'>{item.amount}</td>
                                        <td className='text-right'>{getAmount(item.charges * item.amount)}</td>
                                        <td className='text-right'>{item.receiptId ? 'Paid' : (item.isPending ? 'Pending Clear' : 'Open')}</td>
                                        {canManage && (
                                            <td>
                                                <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                    <Tooltip title="Edit line item">
                                                        <IconButton color="primary" onClick={() => onEdit(item)} size="small">
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Remove line item">
                                                        <IconButton color="error" onClick={() => onRemove(item.uid)} size="small">
                                                            <DeleteOutlineIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Stack>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Box>
                )}

                {status === 'Paid' && !editor && <Typography variant="h6" color="success.main">Payment Success.</Typography>}
            </Stack>
        </Paper>
    )
}

function InvoiceValue({ label, value }) {
    return (
        <Box>
            <Typography variant="body2" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                {value}
            </Typography>
        </Box>
    )
}

function AddComments({ open = false, handleClose, cmts = '', handleCmts }) {

    const schema = yup.object({
        comments: yup.string()
    }).required();

    const { control, handleSubmit, clearErrors, reset } = useForm({
        defaultValues: {
            comments: cmts
        },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        clearErrors()
        reset()
    }, [open, clearErrors, reset])

    const onSubmit = (data) => {
        handleCmts(data)
    }

    return (
        <ToolDialogShell
            open={open}
            onClose={handleClose}
            title="Comments"
        >
            <Stack spacing={3}>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        Invoice comments
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Keep internal notes and supporting context for this invoice in one place.
                    </Typography>
                </Box>

                <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
                    <Stack spacing={2}>
                        <Controller
                            name="comments"
                            control={control}
                            render={({ field }) => (
                                <TextField
                                    label="Comments"
                                    multiline
                                    minRows={8}
                                    fullWidth
                                    {...field}
                                />
                            )}
                        />

                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button onClick={handleClose}>Cancel</Button>
                            <Button variant="contained" onClick={handleSubmit(onSubmit)}>
                                Save
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>
            </Stack>
        </ToolDialogShell>
    )
}


function NewLineItemView({ open = false, handleClose, toggleRefresh }) {

    const schema = yup.object({
        name: yup.string().trim().required(),
        description: yup.string().trim().required(),
        charges: yup.number().required(),
        amount: yup.number().required(),
    }).required();

    const { id } = useParams()

    const { control, handleSubmit, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: { name: '', description: '', charges: '', amount: '' },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        clearErrors()
        reset()
    }, [open, clearErrors, reset])

    const onSubmit = async (data) => {
        await AddLineItem(id, { ...data })
        handleClose()
        toggleRefresh()
    }

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

    return <ResponsiveDialog open={open} onClose={handleClose}>
        <DialogTitle>Line Item</DialogTitle>
        <DialogContent>
            <DialogContentText>&nbsp;</DialogContentText>
            <Controller name="name" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.name)} helperText={errors.name && errors.name.message} fullWidth label='Name' {...field} />} />
            <Controller name="description" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.description)} helperText={errors.description && errors.description.message} fullWidth label='Description' {...field} />} />
            <Controller name="charges" control={control} render={({ field }) => <TextField margin='dense' type="number" error={isError(errors.charges)} helperText={errors.charges && errors.charges.message} fullWidth label='Charges' {...field} />} />
            <Controller name="amount" control={control} render={({ field }) => <TextField margin='dense' type="number" error={isError(errors.amount)} helperText={errors.amount && errors.amount.message} fullWidth label='Quantity' {...field} />} />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSubmit(onSubmit)}>Save</Button>
        </DialogActions>
    </ResponsiveDialog>
}

function LineItemView({ open = false, data, handleClose, handleSave }) {

    const schema = yup.object({
        name: yup.string().trim().required(),
        description: yup.string().trim().required(),
        charges: yup.number().required().min(0, 'Charges must be positive'),
        amount: yup.number().required().min(0, 'Quantity must be positive')
    }).required();

    const { control, handleSubmit, formState: { errors }, clearErrors, reset } = useForm({
        defaultValues: { ...data },
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        clearErrors()
        reset({ ...data })
    }, [open, clearErrors, reset])

    const onSubmit = async (formData) => {
        handleSave(formData)
    }

    const isError = (val) => val !== undefined && val !== null && typeof val === 'object'

    return <ResponsiveDialog open={open} onClose={handleClose}>
        <DialogTitle>Line Item</DialogTitle>
        <DialogContent>
            <DialogContentText>&nbsp;</DialogContentText>
            <Controller name="name" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.name)} helperText={errors.name && errors.name.message} fullWidth label='Name' {...field} />} />
            <Controller name="description" control={control} render={({ field }) => <TextField margin='dense' error={isError(errors.description)} helperText={errors.description && errors.description.message} fullWidth label='Description' {...field} />} />
            <Controller name="charges" control={control} render={({ field }) => <TextField margin='dense' type="number" error={isError(errors.charges)} helperText={errors.charges && errors.charges.message} fullWidth label='Charges' {...field} />} />
            <Controller name="amount" control={control} render={({ field }) => <TextField margin='dense' type="number" error={isError(errors.amount)} helperText={errors.amount && errors.amount.message} fullWidth label='Quantity' {...field} />} />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleSubmit(onSubmit)}>Save</Button>
        </DialogActions>
    </ResponsiveDialog>
}

function EditLateFeeDialog({ open, invoiceId, currentLateFeeType, currentLateFeeValue, handleClose, handleSave }) {
    const [lateFeeType, setLateFeeType] = useState(currentLateFeeType || '')
    const [lateFeeValue, setLateFeeValue] = useState(currentLateFeeValue != null ? String(currentLateFeeValue) : '')

    useEffect(() => {
        setLateFeeType(currentLateFeeType || '')
        setLateFeeValue(currentLateFeeValue != null ? String(currentLateFeeValue) : '')
    }, [open, currentLateFeeType, currentLateFeeValue])

    const onSave = async () => {
        if (!lateFeeType) {
            await UpdateInvoiceLateFee(invoiceId, { lateFeeType: undefined, lateFeeValue: null })
        } else {
            if (!lateFeeValue) {
                alert('Please enter a late fee value')
                return
            }
            await UpdateInvoiceLateFee(invoiceId, {
                lateFeeType,
                lateFeeValue: Number(lateFeeValue)
            })
        }
        handleSave()
    }

    return <WorkflowDialogShell open={open} onClose={handleClose} onSave={onSave} title="Edit Late Fee">
        <>
            <FormControl variant='standard' margin='dense' fullWidth>
                <InputLabel shrink>Late Fee Type</InputLabel>
                <NativeSelect value={lateFeeType} onChange={e => setLateFeeType(e.target.value)} sx={{ mt: 2 }}>
                    <option value=''>None</option>
                    <option value='Percent'>Percentage Based</option>
                    <option value='Flat'>Flat Amount</option>
                </NativeSelect>
            </FormControl>
            {lateFeeType && (
                <TextField margin='dense' type='number' fullWidth
                    label={lateFeeType === 'Flat' ? 'Late Fee ($ flat amount)' : 'Late Fee (%)'}
                    value={lateFeeValue} onChange={e => setLateFeeValue(e.target.value)} />
            )}
        </>
    </WorkflowDialogShell>
}

function PayItems({ items = [], select = [], handleClose, open = false, id, handleSave }) {
    const [paidReceipt, setPaidReceipt] = useState(null)
    const [payAmount, setPayAmount] = useState(null)
    const [payMethod, setPayMethod] = useState('Card')

    // Payer info for offline and ACH payments
    const [payerName, setPayerName] = useState('')
    const [payerEmail, setPayerEmail] = useState('')
    const [payerPhone, setPayerPhone] = useState('')
    const [chequeNum, setChequeNum] = useState('')
    const [notes, setNotes] = useState('')
    const [error, setError] = useState('')

    const totalDue = () => {
        return items.filter(e => select.includes(e._id)).reduce((acc, val) => acc + val.amount * val.charges, 0)
    }

    // Editable amount defaults to the full amount due; reset whenever the dialog is (re)opened for a new selection.
    useEffect(() => {
        if (open) {
            setPayAmount(totalDue())
            setPayMethod('Card')
            setPayerName('')
            setPayerEmail('')
            setPayerPhone('')
            setChequeNum('')
            setNotes('')
            setError('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, select])

    const amountToCharge = payAmount === null ? totalDue() : payAmount
    const balanceDiff = Math.round((totalDue() - amountToCharge) * 100) / 100
    
    // Overpayment is allowed across all methods (Card, ACH, Cash, Cheque) and is automatically credited to tenant balance.
    const isOffline = payMethod === 'Cash' || payMethod === 'Cheque';
    const amountValid = amountToCharge > 0;

    const handleComplete = (receipt) => {
        const data = {
            receipt,
            lineItems: items.filter(e => select.includes(e._id)),
            paidAmount: amountToCharge,
            payer: {
                name: payerName,
                email: payerEmail,
                relation: 'Tenant'
            }
        }
        PayLineItem(id, data).then(() => {
            setPaidReceipt({ amount: amountToCharge, confirmation: receipt?.confirmation || receipt?.id || '', method: payMethod })
            handleSave()
        }).catch(err => {
            setError(err.response?.data?.message || 'Recording payment failed')
        })
    }

    const handleOfflinePay = () => {
        if (!payerName.trim() || !payerEmail.trim()) {
            setError('Payer Name and Email are required.')
            return
        }
        if (payMethod === 'Cheque' && !chequeNum.trim()) {
            setError('Cheque Number is required.')
            return
        }
        setError('')

        const receipt = {
            accountName: payMethod,
            accountDetails: payMethod === 'Cheque' ? `Cheque #${chequeNum}` : 'Cash Payment',
            paymentDate: new Date().toISOString(),
            confirmation: payMethod === 'Cheque' ? chequeNum : 'CASH',
            payerName,
            payerEmail,
            payerRelation: 'Tenant'
        }

        handleComplete(receipt)
    }

    const onClose = () => { setPaidReceipt(null); handleClose() }

    return <ResponsiveDialog open={open} onClose={onClose}>
        <DialogTitle>{paidReceipt ? 'Payment Successful' : <>Pay {getAmount(totalDue())}</>}</DialogTitle>
        <DialogContent>
            {paidReceipt ? (
                <Box sx={{ textAlign: 'center', py: 1 }}>
                    <Box sx={{
                        width: 64, height: 64, borderRadius: '50%',
                        bgcolor: 'success.light', color: 'success.dark',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        mx: 'auto', mb: 2
                    }}>
                        <CheckCircleOutlineIcon sx={{ fontSize: 36 }} />
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Your payment has been processed successfully.
                    </Typography>
                    <Paper variant="outlined" sx={{ borderRadius: 2, textAlign: 'left', px: 2.5, py: 1.5 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.75, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary">Amount Paid</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{getAmount(paidReceipt.amount)}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.75, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary">Payment Method</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{paidReceipt.method}</Typography>
                        </Box>
                        {paidReceipt.confirmation && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.75 }}>
                                <Typography variant="body2" color="text.secondary">Confirmation #</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: 'monospace', wordBreak: 'break-all' }}>{paidReceipt.confirmation}</Typography>
                            </Box>
                        )}
                    </Paper>
                    <Button fullWidth variant="contained" sx={{ mt: 2.5 }} onClick={onClose}>
                        Close
                    </Button>
                </Box>
            ) : (
                <>
                    <DialogContentText>&nbsp;</DialogContentText>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                    <TextField
                        select
                        fullWidth
                        label="Payment Method"
                        size="small"
                        value={payMethod}
                        onChange={e => {
                            setPayMethod(e.target.value)
                            setError('')
                        }}
                        SelectProps={{ native: true }}
                        sx={{ mb: 2 }}
                    >
                        <option value="Card">Credit / Debit Card</option>
                        <option value="Cash">Cash</option>
                        <option value="Cheque">Cheque (Paper)</option>
                        <option value="ACH">e-Cheque / ACH</option>
                    </TextField>

                    <TextField
                        label="Amount to Pay"
                        type="number"
                        fullWidth
                        size="small"
                        value={payAmount === null ? '' : payAmount}
                        onChange={e => {
                            const v = e.target.value
                            setPayAmount(v === '' ? 0 : Math.max(0, Number(v)))
                        }}
                        inputProps={{ step: 0.01, min: 0.01 }}
                        sx={{ mb: 2 }}
                        error={!amountValid}
                        helperText={
                            amountValid
                                ? (amountToCharge > totalDue()
                                    ? `Amount Due: $${Number(totalDue()).toFixed(2)}. Overpayment of $${(amountToCharge - totalDue()).toFixed(2)} will be credited to tenant balance.`
                                    : `Amount Due: $${Number(totalDue()).toFixed(2)}`)
                                : `Enter a valid amount greater than $0.`
                        }
                    />

                    {isOffline && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600 }}>Payer Information</Typography>
                            <TextField
                                label="Payer Name"
                                size="small"
                                fullWidth
                                value={payerName}
                                onChange={e => setPayerName(e.target.value)}
                            />
                            <TextField
                                label="Payer Email"
                                size="small"
                                fullWidth
                                type="email"
                                value={payerEmail}
                                onChange={e => setPayerEmail(e.target.value)}
                            />
                            <TextField
                                label="Payer Phone"
                                size="small"
                                fullWidth
                                value={payerPhone}
                                onChange={e => setPayerPhone(e.target.value)}
                            />
                            {payMethod === 'Cheque' && (
                                <TextField
                                    label="Cheque Number"
                                    size="small"
                                    fullWidth
                                    value={chequeNum}
                                    onChange={e => setChequeNum(e.target.value)}
                                />
                            )}
                            <TextField
                                label="Notes / Transaction Details"
                                size="small"
                                fullWidth
                                multiline
                                rows={2}
                                value={notes}
                                onChange={e => setNotes(e.target.value)}
                            />
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={handleOfflinePay}
                                disabled={!amountValid || !payerName.trim() || !payerEmail.trim() || (payMethod === 'Cheque' && !chequeNum.trim())}
                            >
                                Record Offline {payMethod} Payment
                            </Button>
                        </Box>
                    )}

                    {balanceDiff > 0 && !isOffline && (
                        <Alert severity="warning" sx={{ mb: 2 }}>
                            Remaining {getAmount(balanceDiff)} will stay open on this invoice as still due.
                        </Alert>
                    )}

                    {amountValid && payMethod === 'Card' && (
                        <PayCardStripe amount={amountToCharge} invoiceId={id} lineItemUids={items.filter(e => select.includes(e._id)).map(e => e.uid).join(',')} onComplete={handleComplete} />
                    )}

                    {amountValid && payMethod === 'ACH' && (
                        <PayAchStripe amount={amountToCharge} invoiceId={id} lineItemUids={items.filter(e => select.includes(e._id)).map(e => e.uid).join(',')} payerEmail={payerEmail} onComplete={handleComplete} />
                    )}
                </>
            )}
        </DialogContent>
    </ResponsiveDialog>
}


